import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from '@ridango/core';

import { ValidationHistoryActions, ValidationHistoryEpics, ValidationHistoryFacade } from './+state';
import { ValidationHistoryService } from './validation-history.service';

@NgModule({
    declarations: [],
    imports: [CoreModule, CommonModule],
    providers: [ValidationHistoryActions, ValidationHistoryFacade, ValidationHistoryEpics, ValidationHistoryService],
})
export class ValidationHistoryModule {}
